import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Phone, Mail, MapPin, CheckCircle2 } from 'lucide-react';
export function FinalCTA() {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitted(true);
    // Mock submission delay
    setTimeout(() => {
      // Reset form or keep success state
    }, 3000);
  };
  return <section id="contact" className="section-padding bg-navy text-white relative overflow-hidden" data-id="element-44">
      {/* Background Image with heavy overlay */}
      <div className="absolute inset-0 z-0" data-id="element-45">
        <img src="https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https%3A//assets.cdn.filesafe.space/cMkAnz3QfJpQ1Lp2u0QG/media/69160e58039bdcddece085c9.png" alt="Trucking Highway" className="w-full h-full object-cover object-center" data-id="element-46" />
        <div className="absolute inset-0 bg-navy/95" data-id="element-47"></div>
      </div>

      <div className="container-custom relative z-10" data-id="element-48">
        <div className="grid lg:grid-cols-2 gap-16 lg:gap-24" data-id="element-49">
          {/* Left: Copy & Contact Info */}
          <div data-id="element-50">
            <span className="eyebrow text-amber" data-id="element-51">Business Intake</span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold font-heading mb-6 leading-tight" data-id="element-52">
              Tell Us What Is Slowing the Business Down
            </h2>
            <div className="w-16 h-1.5 bg-red mb-8" data-id="element-53"></div>
            <p className="text-lg text-white/80 leading-relaxed mb-4 font-medium" data-id="element-54">
              Start with a free 1:1 consultation. FleetScale will help identify
              the bottleneck, clarify the opportunity, and show you what a
              practical roadmap could look like.
            </p>
            <p className="text-sm text-white/50 mb-12 font-bold uppercase tracking-wider" data-id="element-55">
              No pressure. Just a practical conversation about your operations.
            </p>

            <div className="space-y-8 border-t border-white/10 pt-8" data-id="element-56">
              <div className="flex items-center" data-id="element-57">
                <div className="w-12 h-12 bg-black/50 flex items-center justify-center rounded-sm mr-5 border border-white/10" data-id="element-58">
                  <Phone className="w-5 h-5 text-amber" data-id="element-59" />
                </div>
                <div data-id="element-60">
                  <div className="text-xs uppercase tracking-wider text-white/50 font-bold mb-1" data-id="element-61">
                    Direct Line
                  </div>
                  <a href="tel:4405840093" className="text-xl font-bold hover:text-amber transition-colors" data-id="element-62">
                    (440) 584-0093
                  </a>
                </div>
              </div>

              <div className="flex items-center" data-id="element-63">
                <div className="w-12 h-12 bg-black/50 flex items-center justify-center rounded-sm mr-5 border border-white/10" data-id="element-64">
                  <Mail className="w-5 h-5 text-amber" data-id="element-65" />
                </div>
                <div data-id="element-66">
                  <div className="text-xs uppercase tracking-wider text-white/50 font-bold mb-1" data-id="element-67">
                    Email
                  </div>
                  <a href="mailto:info@fleetscalegroup.com" className="text-xl font-bold hover:text-amber transition-colors" data-id="element-68">
                    info@fleetscalegroup.com
                  </a>
                </div>
              </div>

              <div className="flex items-center" data-id="element-69">
                <div className="w-12 h-12 bg-black/50 flex items-center justify-center rounded-sm mr-5 border border-white/10" data-id="element-70">
                  <MapPin className="w-5 h-5 text-amber" data-id="element-71" />
                </div>
                <div data-id="element-72">
                  <div className="text-xs uppercase tracking-wider text-white/50 font-bold mb-1" data-id="element-73">
                    Headquarters
                  </div>
                  <div className="text-lg font-medium text-white/90" data-id="element-74">
                    77 Milford Dr Suite 251
                    <br data-id="element-75" />
                    Hudson, OH 44236
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right: Form */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white p-8 md:p-10 rounded-sm shadow-2xl text-navy relative" data-id="element-76">
            {isSubmitted ? <div className="absolute inset-0 bg-white flex flex-col items-center justify-center p-10 text-center rounded-sm z-20" data-id="element-77">
                <div className="w-20 h-20 bg-green-50 rounded-full flex items-center justify-center mb-6" data-id="element-78">
                  <CheckCircle2 className="w-10 h-10 text-green-600" data-id="element-79" />
                </div>
                <h3 className="text-2xl font-bold font-heading text-navy mb-4" data-id="element-80">
                  Request Received
                </h3>
                <p className="text-body/80 mb-8" data-id="element-81">
                  Thank you. A FleetScale advisor will review your information
                  and reach out shortly to schedule your consultation.
                </p>
                <button onClick={() => setIsSubmitted(false)} className="text-sm font-bold text-navy/50 hover:text-navy uppercase tracking-wider" data-id="element-82">
                  Submit another request
                </button>
              </div> : null}

            <div className="mb-8 pb-6 border-b border-steel" data-id="element-83">
              <h3 className="text-2xl font-bold font-heading text-navy" data-id="element-84">
                Request Consultation
              </h3>
              <p className="text-sm text-body/60 mt-2" data-id="element-85">
                Fill out the details below to get started.
              </p>
            </div>

            <form className="space-y-5" onSubmit={handleSubmit} data-id="element-86">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-87">
                <div data-id="element-88">
                  <label className="block text-xs font-bold uppercase tracking-wider text-navy/70 mb-2" data-id="element-89">
                    Name *
                  </label>
                  <input required type="text" className="w-full bg-off-white border border-steel px-4 py-3.5 rounded-sm focus:outline-none focus:border-navy focus:ring-1 focus:ring-navy transition-colors font-medium" placeholder="John Doe" data-id="element-90" />
                </div>
                <div data-id="element-91">
                  <label className="block text-xs font-bold uppercase tracking-wider text-navy/70 mb-2" data-id="element-92">
                    Company *
                  </label>
                  <input required type="text" className="w-full bg-off-white border border-steel px-4 py-3.5 rounded-sm focus:outline-none focus:border-navy focus:ring-1 focus:ring-navy transition-colors font-medium" placeholder="Transport LLC" data-id="element-93" />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-94">
                <div data-id="element-95">
                  <label className="block text-xs font-bold uppercase tracking-wider text-navy/70 mb-2" data-id="element-96">
                    Phone *
                  </label>
                  <input required type="tel" className="w-full bg-off-white border border-steel px-4 py-3.5 rounded-sm focus:outline-none focus:border-navy focus:ring-1 focus:ring-navy transition-colors font-medium" placeholder="(555) 123-4567" data-id="element-97" />
                </div>
                <div data-id="element-98">
                  <label className="block text-xs font-bold uppercase tracking-wider text-navy/70 mb-2" data-id="element-99">
                    Email *
                  </label>
                  <input required type="email" className="w-full bg-off-white border border-steel px-4 py-3.5 rounded-sm focus:outline-none focus:border-navy focus:ring-1 focus:ring-navy transition-colors font-medium" placeholder="john@company.com" data-id="element-100" />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-101">
                <div data-id="element-102">
                  <label className="block text-xs font-bold uppercase tracking-wider text-navy/70 mb-2" data-id="element-103">
                    Approx. Fleet Size
                  </label>
                  <input type="text" className="w-full bg-off-white border border-steel px-4 py-3.5 rounded-sm focus:outline-none focus:border-navy focus:ring-1 focus:ring-navy transition-colors font-medium" placeholder="e.g. 15 trucks" data-id="element-104" />
                </div>
                <div data-id="element-105">
                  <label className="block text-xs font-bold uppercase tracking-wider text-navy/70 mb-2" data-id="element-106">
                    Biggest Bottleneck
                  </label>
                  <select className="w-full bg-off-white border border-steel px-4 py-3.5 rounded-sm focus:outline-none focus:border-navy focus:ring-1 focus:ring-navy transition-colors appearance-none font-medium text-navy" data-id="element-107">
                    <option value="" data-id="element-108">Select one...</option>
                    <option value="recruiting" data-id="element-109">Driver recruiting</option>
                    <option value="dispatch" data-id="element-110">Dispatch/load management</option>
                    <option value="backoffice" data-id="element-111">Back office/cash flow</option>
                    <option value="compliance" data-id="element-112">Compliance/risk</option>
                    <option value="technology" data-id="element-113">
                      Technology/data visibility
                    </option>
                    <option value="growth" data-id="element-114">Growth strategy</option>
                    <option value="notsure" data-id="element-115">Not sure yet</option>
                  </select>
                </div>
              </div>

              <div data-id="element-116">
                <label className="block text-xs font-bold uppercase tracking-wider text-navy/70 mb-2" data-id="element-117">
                  Message
                </label>
                <textarea rows={4} className="w-full bg-off-white border border-steel px-4 py-3.5 rounded-sm focus:outline-none focus:border-navy focus:ring-1 focus:ring-navy transition-colors font-medium" placeholder="Briefly describe what's trapping you in day-to-day operations..." data-id="element-118"></textarea>
              </div>

              <button type="submit" className="btn-primary w-full py-4 text-base mt-6 shadow-lg hover:shadow-xl" data-id="element-119">
                Request Free Consultation
              </button>
            </form>
          </motion.div>
        </div>
      </div>
    </section>;
}